// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3609 ? "aafbaf63" : chunkId) + "." + {"2652":"bf22de224b175f6c","3609":"36443b0ce0ff558a","6759":"292159d28625c592"}[chunkId] + ".js";
};